<template>
    <form class="nowpayments-form" @submit.prevent="submitHandler">
      <div
        v-if="!$auth.check()"
        class="form-group"
        :class="{ error: $v.form.email.$error }"
      >
        <label>
          {{ $t("labels.email") }}
        </label>
        <div class="input-group">
          <input
            type="text"
            required="required"
            :placeholder="$t('placeholder.email')"
            class="form-control"
            v-model="form.email"
            @input="$v.form.email.$touch"
          />
        </div>
        <template v-if="$v.form.email.$error">
          <p class="error-message" v-if="!$v.form.email.required">
            {{ $t("validations.required", { field: $t("fields.email") }) }}
          </p>
        </template>
      </div>
      <div
        v-if="!$auth.check()"
        class="form-group"
        :class="{ error: $v.form.email_confirm.$error }"
      >
        <label>
          {{ $t("labels.email_confirm") }}
        </label>
        <div class="input-group">
          <input
            type="text"
            required="required"
            :placeholder="$t('placeholder.email_confirm')"
            class="form-control"
            v-model="form.email_confirm"
            @input="$v.form.email_confirm.$touch"
          />
        </div>
        <template v-if="$v.form.email_confirm.$error">
          <p class="error-message" v-if="!$v.form.email_confirm.required">
            {{ $t("validations.sameAs", { field: $t("fields.email") }) }}
          </p>
        </template>
      </div>
      <div class="form-group" :class="{ error: $v.form.over_age.$error }">
        <label>
          <input type="checkbox" v-model="form.over_age" />
          <i18n
            path="subscription.payment_legals.accept.over_age"
            tag="span"
          ></i18n>
        </label>
        <template v-if="$v.form.over_age.$error">
          <p class="error-message" v-if="!$v.form.over_age.accepted">
            {{ $t("validations.accepted", { field: $t("fields.terms") }) }}
          </p>
        </template>
      </div>
      <div class="form-group" :class="{ error: $v.form.terms.$error }">
        <label>
          <input type="checkbox" v-model="form.terms" />
          <i18n
            path="subscription.payment_legals.accept.label_recurrent"
            tag="span"
          >
            <template>
              <a :href="termsUrl" target="_blank">{{
                $t("subscription.payment_legals.accept.terms")
              }}</a>
            </template>
            <template>
              <a :href="privacyUrl">{{
                $t("subscription.payment_legals.accept.privacy")
              }}</a>
            </template>
            <template>
              <router-link :to="{ name: 'support' }">{{
                $t("zammad_support.link")
              }}</router-link>
            </template>
          </i18n>
        </label>
        <template v-if="$v.form.terms.$error">
          <p class="error-message" v-if="!$v.form.terms.accepted">
            {{ $t("validations.accepted", { field: $t("fields.terms") }) }}
          </p>
        </template>
      </div>
  
      <ResultMessage
        v-if="resultMessage.message"
        :result-message="resultMessage"
      />
  
      <div class="buttons-container">
        <template v-if="form.accept_no_trial">
          <p class="no-trial-message">
            {{ $t("subscription.not_elegible_for_free_trial") }}
          </p>
          <button type="submit" class="btn main-btn submit">
            {{ $t("subscription.buttons.pay_without_trial") }}
          </button>
        </template>
        <template v-else-if="form.accept_no_promo">
          <p class="no-promo-message">
            {{ $t("subscription.promo_unsuported") }}
          </p>
          <button type="submit" class="btn main-btn submit">
            {{ $t("subscription.buttons.pay_without_promo") }}
          </button>
        </template>
        <template v-else>
          <button type="submit" class="btn main-btn submit">
            {{ $t("subscription.buttons.pay") }}
          </button>
        </template>
      </div>
    </form>
  </template>
  <script>
  import Spinner from "../Spinner";
  import { email, requiredIf } from "vuelidate/lib/validators";
  import ResultMessage from "../ResultMessage";
  import EventBus from "../../eventbus";
  
  export default {
    components: {
      Spinner,
      ResultMessage,
    },
    props: {
      purchaseOption: {
        type: Object,
        required: false,
      },
      resultMessage: {
        required: true,
      },
      hasToAcceptNoTrial: {
        required: true,
        default: false,
      },
      hasToAcceptNoPromo: {
        required: true,
        default: false,
      },
      paymentCountry: {
        required: true,
      },
    },
    data() {
      return {
        form: {
          email: "",
          email_confirm: "",
          terms: false,
          over_age: false,
          accept_no_trial: false,
          accept_no_promo: false,
          addon_legacy: true,
          payment_country_id: null,
        },
      };
    },
    validations() {
      return {
        form: {
          email: {
            requiredIf: requiredIf(function () {
              //Si no esta logueado tiene que completar el email
              return !this.$auth.check();
            }),
            email,
          },
          email_confirm: {
            requiredIf: requiredIf(function () {
              //Si no esta logueado tiene que completar el email
              return !this.$auth.check();
            }),
            sameAs(value) {
              return value === this.form.email;
            },
          },
          terms: {
            accepted(value) {
              return value === true;
            },
          },
          over_age: {
            accepted(value) {
              return value === true;
            },
          },
        },
      };
    },
    watch: {
      hasToAcceptNoTrial(hasToAcceptNoTrial) {
        if (hasToAcceptNoTrial === null) {
          this.form.accept_no_trial = false;
        } else {
          this.form.accept_no_trial = !!hasToAcceptNoTrial;
        }
      },
      hasToAcceptNoPromo(hasToAcceptNoPromo) {
        if (hasToAcceptNoPromo === null) {
          this.form.accept_no_promo = false;
        } else {
          this.form.accept_no_promo = !!hasToAcceptNoPromo;
        }
      },
      paymentCountry(newVal) {
        this.form.payment_country_id = newVal;
      },
    },
    methods: {
      submitHandler() {
        if (this.$v.form.$invalid) {
          this.$v.form.$touch();
        } else {
          this.$emit("submit", this.form);
        }
      },
    },
    mounted() {
      this.form.payment_country_id = this.paymentCountry;

      if (!this.$v.form.$invalid) {
        this.$emit("submit", this.form);
      }

      EventBus.$on("addon_legacy", (value) => {
        this.form.addon_legacy = value;
      });
    },
    computed: {
      termsUrl() {
        let langCode = this.$i18n.locale;
        return `/legals/terms/${langCode}.html`;
      },
      privacyUrl() {
        return "https://divasplay.com/legals/privacy.html";
      },
      supportAddress() {
        return `soporte@divasplay.com`;
      },
    },
  };
  </script>
  <style scoped lang="scss">
  @import "../../styles/variables";
  @import "../../styles/classes";
  
  .nowpayments-form {
    text-align: center;
    margin: 30px;
    padding: 30px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    min-width: 250px;
  
    .btn.submit {
      @extend %fresh-btn;
      font-size: 2em;
    }
  
    .legals {
      a {
        font-weight: bold;
        text-decoration: underline;
      }
  
      span {
        font-size: 0.75em;
      }
    }
  }
  </style>
  